import React, { createContext, useContext, useState, useEffect } from 'react';
import {
	defaultColDefination,
	initialGridData,
} from 'CategoryManagement/Explore/DetailedAnalysis/utils';
import { CategoryManagementContext } from 'contexts/CategoryManagementContext';
import { getNonPreferdSuppliers } from 'utils/apiRequests';
import { CategoryInsightsSettingsContext } from 'contexts/CategoryInsightsSettingsContext';
import { formatNumber } from 'utils/number';

const NonPreferedSuppliersContext = createContext();

const suppliersText = 'suppliers';
const columnDefs = [
	{ headerName: 'Vendor Name', field: 'vendor_Name' },
	{ headerName: 'Is Prefered', field: 'is_Preferred', hide: true },
	{ headerName: 'AP L1Category', field: 'aP_L1Category' },
	{ headerName: 'AP L2Category', field: 'aP_L2Category' },
	{ headerName: 'AP L3Category', field: 'aP_L3Category' },
	{ headerName: 'AP L4Category', field: 'aP_L4Category' },
	{ headerName: 'Business Unit', field: 'bussiness_Units' },
	{ headerName: 'Vendor Segmentation', field: 'vendor_Segmentation' },
	{ headerName: 'Contracts', field: 'contracts' },
	{ headerName: 'Country', field: 'country', hide: true },
	{ headerName: 'Year', field: 'year', hide: true },
];

export const NonPreferedSuppliersProvider = ({ children }) => {
	const [isLoading, setIsLoading] = useState(false);
	const [analysis, setAnalysis] = useState(`X ${suppliersText}`);

	const [gridData, setGridData] = useState(initialGridData);
	const {
		currentSelectCategory,
		dateRangeData,
		isFetching,
		segmentationUpdatedCount,
	} = useContext(CategoryManagementContext);
	const { loading: isSettingsFetching } = useContext(
		CategoryInsightsSettingsContext
	);
	const { categoryName } = currentSelectCategory;
	const { dateFrom, dateTo } = dateRangeData;

	useEffect(
		() => {
			if (!isSettingsFetching && !isFetching) {
				setIsLoading(true);
				if (
					categoryName !== '' ||
					categoryName !== null ||
					categoryName !== undefined
				) {
					const payLoad = {
						categoryName: categoryName,
						dateFrom: dateFrom,
						dateTo: dateTo,
					};
					getNonPreferdSuppliers(payLoad)
						.then(response => {
							if (response.succeeded) {
								if (response.data.length > 0 || response.data !== null) {
									if (!!Object.keys(response.data).length) {
										if (response.data.explore.length > 0) {
											const analysisString = `${formatNumber(
												response.data.nonPreferredCount
											)} ${suppliersText}`;
											setAnalysis(analysisString);
											setGridData(prevState => ({
												...prevState,
												rowData: response.data.explore,
												columnDefs: columnDefs,
												defaultColDef: defaultColDefination,
											}));
										} else {
											setAnalysis(`0 ${suppliersText}`);
										}
										setIsLoading(false);
									}
								} else {
									setIsLoading(false);
								}
							} else {
								setAnalysis('Supplier not present.');
								setGridData(initialGridData);
								setIsLoading(false);
							}
						})
						.catch(() => setIsLoading(false));
				} else {
					setIsLoading(false);
				}
			}
		}, // eslint-disable-next-line
		[
			dateRangeData,
			categoryName,
			isSettingsFetching,
			isFetching,
			segmentationUpdatedCount,
		]
	);

	return (
		<NonPreferedSuppliersContext.Provider
			value={{ isLoading, analysis, gridData }}
		>
			{children}
		</NonPreferedSuppliersContext.Provider>
	);
};

export const useNonPreferedSuppliersContext = () => {
	return useContext(NonPreferedSuppliersContext);
};
